module.exports = __webpack_public_path__ + "img/part-3-title.54764c76.png";